import React, { FC, ReactNode, useEffect, useState } from 'react'
import styles from './Collapsable.module.scss'
import ExpandLessIcon from 'svg/expand-less.svg'
import ExpandMoreIcon from 'svg/expand-more.svg'
import classNames from 'classnames'
import Toggle from 'components/SA/FormElements/Toggle'

export type CollapsableProps = {
  title?: string
  disableCollapsable?: boolean
  content?: ReactNode
  isOpen?: boolean
  isToggle?: boolean
  onClick?: (isExpanded: boolean) => void
}

const Collapsable: FC<CollapsableProps> = ({
  title,
  content,
  disableCollapsable,
  isOpen,
  isToggle,
  onClick,
}) => {
  const [isExpanded, setIsExpanded] = useState(Boolean(isOpen))
  const isExpandedIcon = !disableCollapsable && isExpanded

  const handleToggleOnClick = () => {
    setIsExpanded((prevValue) => {
      const nextValue = !prevValue
      onClick?.(nextValue)

      return nextValue
    })
  }

  useEffect(() => {
    setIsExpanded(!!isOpen)
  }, [isOpen])

  return (
    <div className={styles.collapsableContainer}>
      {title && (
        <button
          data-type='collapsable-filter'
          aria-controls={`section-${title}`}
          aria-expanded={isExpanded}
          aria-label={`Toggle ${title}`}
          onClick={!isToggle ? handleToggleOnClick : undefined}
          className={classNames({ [styles.buttonIsToggle]: isToggle })}
        >
          <span className={styles.collapsableTitle}>{title}</span>
          {isToggle && <Toggle value={!!isExpanded} onToggle={handleToggleOnClick} />}
          {!isToggle && (isExpandedIcon ? <ExpandLessIcon /> : <ExpandMoreIcon />)}
        </button>
      )}
      {content && (
        <div
          className={classNames({ [styles.collapsableContentHidden]: !isExpanded })}
          id={`section-${title}`}
          aria-hidden={!isExpanded}
          {...(isExpanded
            ? {
                'data-visible': 'true',
              }
            : { hidden: true })}
        >
          {content}
        </div>
      )}
    </div>
  )
}

export default Collapsable
